<template lang="html">
  <div class="domain-help">
    <Guide
      width="x-small"
      contentHeading="Connect Your Domain"
      buttonText="Finish"
      :autoHeight="domainQuery"
      :content="content"
      :closeLink="closeLink"
      :nextLink="domainQuery ? false : closeLink"
      :previousLink="domainQuery ? false : previousLink">

      <Notification
        v-if="notification.active"
        :content="notification.content"
        :type="notification.type" />

      <hr :class="{'is-connecting': domainResult.result}">

      <div v-if="domainConnectionAttempted">
        <div class="helper-text dns-success" v-if="domainResult.valid">
          <p>
            <strong>
              We're now generating a certificate for the domain name {{domainName}}.
            </strong>
          </p>
          <p>
            This process may take a couple of minutes. It may take up a few hours for your domain to become accessible for everybody.
          </p>
        </div>

        <div class="helper-text dns-error" v-else>
          <p>This domain name is currently pointing to <strong>{{domainResult.result}}</strong>. Please ensure that your A Records are pointing to <strong>206.189.31.34</strong> and try again.</p>
        </div>
      </div>

      <form v-if="!domainConnected" @submit.prevent="generateCertificate">
        <div class="input" v-if="!domainQuery">
          <div class="input-wrapper">
            <span>www.</span>
            <input v-model="domainName" placeholder="my-domain-name.com">
          </div>
        </div>

        <div v-else>
          <h3 class="centered">{{domainQuery}}</h3>
        </div>

        <Btn
          class="btn-check-domain"
          isBlock
          :pulse="domainQuery"
          :isDisabled="domainName.length === 0 && !domainQuery"
          tertiary>Generate and Connect</Btn>
      </form>
    </Guide>
  </div>
</template>

<script>
import Btn from '@/components/Btn'
import Guide from '@/components/Guide'

import {createSiteCertificateData} from '@/lib/certificates'
import {checkDomainDnsData} from '@/lib/domains'
import {updateCompanySiteData} from '@/lib/sites'

import notification from '@/mixins/notification'

export default {
  name: 'DomainDnsCheck',

  mixins: [notification],

  components: {
    Guide,
    Btn
  },

  data() {
    return {
      domain: '',
      domainResult: {},
      domainConnected: false,
      domainConnectionAttempted: false
    }
  },

  props: {
    siteId: String,
    companyId: String
  },

  methods: {
    generateCertificate() {
      checkDomainDnsData(this.companyId, this.domain)
        .then(({data}) => {
          this.domainResult = data

          let certificate = {
            domain: this.domain,
            is_preview: false
          }

          if (data.valid) {
            createSiteCertificateData(
              this.siteId,
              certificate
            ).then(({data}) => {
              let site = {
                domain: this.domain
              }

              updateCompanySiteData(this.companyId, this.siteId, site)
                .then(({data}) => {
                  this.triggerNotification('success', 'domain', 'connected', true)

                  window.setTimeout(() => {
                    this.domainConnected = true
                  }, this.closeDelay)
                })
            })
          } else {
            this.triggerNotification('error', 'domain', 'not connected')
            this.domainConnected = false
          }

          this.domainConnectionAttempted = true
        })
    }
  },

  computed: {
    domainName: {
      get() {
        let domain = this.domain
        return domain
      },

      set(value) {
        let domain = value.replace(/\s+/g, '-').toLowerCase()
        this.domain = domain
      }
    },

    domainQuery() {
      return this.$route.query.domain
    },

    closeLink() {
      if (this.domainQuery) {
        return {
          name: 'company-domain',
          params: {
            companyId: this.companyId,
            siteId: this.siteId,
            domain: this.domain
          }
        }
      } else {
        return {
          name: 'domain-settings',
          params: {
            companyId: this.companyId,
            siteId: this.siteId
          }
        }
      }
    },

    previousLink() {
      return {
        name: 'domain-dns-config',
        params: {
          companyId: this.companyId,
          siteId: this.siteId
        }
      }
    },

    content() {
      return `
        <p>PageMakerPro will generate a <strong>FREE SSL certificate</strong> for your domain name.</p>
        <div class="helper-text">
          <p>This means that your visitors will see a green secure lock icon when browsing your website in their browsers address bar. Your website will also start with <strong>https://</strong></p>
        </div>
      `
    }
  },

  mounted() {
    if (this.domainQuery) {
      this.domain = this.domainQuery
    }
  }
}

</script>

<style lang="sass" scoped>
.btn-check-domain
  text-align: center
  margin-bottom: 30px

.dns-error, .dns-success
  margin-bottom: 20px

.dns-error
  background: rgba(255, 0, 0, 0.1)

.dns-success
  background: rgba(48, 205, 109, 0.2)

hr
  transition: margin .2s ease-in-out

  &.is-connecting
    margin: 20px 0
</style>
